import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import Modal from '../shared/Modal';
import { Mail, MessageSquare, Smartphone } from 'lucide-react';
import TextInput from '../InputComponent/TextInput';
import TextAreaInput from '../InputComponent/TextAreaInput';
import SelectInput from '../InputComponent/SelectInput';

const channels = [
    { id: 'email', name: 'Email', icon: Mail },
    // { id: 'SMS', name: 'SMS', icon: MessageSquare },
    // { id: 'WhatsApp', name: 'WhatsApp', icon: Smartphone }, // Using Smartphone as proxy
    { id: 'app', name: 'App Push', icon: Smartphone },
];

const SendNotificationModal = ({ isOpen, onClose, onSend, users, members, trainers, isLoading }) => {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [targetGroup, setTargetGroup] = useState('all');
    const [specificUser, setSpecificUser] = useState('');
    const [selectedChannels, setSelectedChannels] = useState(['app']);
    const [scheduleTime, setScheduleTime] = useState('');

    const handleChannelToggle = (channelId) => {
        setSelectedChannels(prev =>
            prev.includes(channelId)
                ? prev.filter(id => id !== channelId)
                : [...prev, channelId]
        );
    };
    useEffect(() => {
        // Reset form
        setTitle('');
        setMessage('');
        setTargetGroup('all');
        setSpecificUser('');
        setSelectedChannels(['app']);
        setScheduleTime('');
    }, [isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!title || !message || selectedChannels.length === 0) {
            toast.error('Title, message, and at least one channel are required.');
            return;
        }

        let targetAudience = 'all';
        if (targetGroup === 'user' && specificUser) {
            targetAudience = users.find(u => u.id === specificUser)?.name || 'user';
        } else if (targetGroup === 'trainers' && specificUser) {
            targetAudience = users.find(u => u.id === specificUser)?.name || 'trainers';
        } else if (targetGroup !== 'all') {
            toast.error('Please select a specific person for the chosen target group.');
            return;
        }

        onSend({
            title,
            message,
            targetAudience,
            specificUser,
            channels: selectedChannels,
            scheduleTime: scheduleTime || null,
        });
    };

    const getTargetUsers = () => {
        if (targetGroup === 'user') {
            return members;
        }
        if (targetGroup === 'trainers') {
            return trainers;
        }
        return [];
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Send Notification">
            <form onSubmit={handleSubmit} className="space-y-4">
                <TextInput label={"Title"} type="text" value={title} onChange={e => setTitle(e.target.value)} isRequired={true} />
                <TextAreaInput label={"Message"} value={message} onChange={e => setMessage(e.target.value)} rows="4" isRequired={true} />
                <SelectInput label={"Target Group"} value={targetGroup} onChange={e => { setTargetGroup(e.target.value); setSpecificUser(''); }}>
                    <option value="all">All Members</option>
                    <option value="user">Specific Member</option>
                    <option value="trainers">Specific Trainer</option>
                </SelectInput>
                {(targetGroup === 'user' || targetGroup === 'trainers') && (
                    <SelectInput label={"Select Person"} value={specificUser} onChange={e => setSpecificUser(e.target.value)}>
                        <option value="" disabled>Select a person...</option>
                        {getTargetUsers().map(user => <option key={user.id} value={user.id}>{user.name}</option>)}
                    </SelectInput>)}
                 
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Channels</label>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                        {channels.map(channel => (
                            <button key={channel.id} type="button" onClick={() => handleChannelToggle(channel.id)} className={`flex items-center justify-center gap-2 p-2 rounded-lg border-2 transition-all ${selectedChannels.includes(channel.id) ? 'bg-red-50 border-brand-red text-brand-red' : 'bg-gray-100 border-transparent text-gray-500 hover:bg-gray-200'}`}>
                                <channel.icon size={16} />
                                <span className="font-medium text-xs">{channel.name}</span>
                            </button>
                        ))}
                    </div>
                </div>
                {/* <div>
                    <label className="block text-sm font-medium text-gray-700">Schedule (Optional)</label>
                    <input type="datetime-local" value={scheduleTime} onChange={e => setScheduleTime(e.target.value)} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm" />
                </div> */}
                <div className="pt-4 flex justify-end gap-3">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Cancel</button>
                    <button type="submit" disabled={isLoading} className="px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">
                        {/* {scheduleTime ? 'Schedule Notification' : 'Send Now'} */}  {isLoading ? 'Loading..' : 'Send Now'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default SendNotificationModal;
